import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { FeedbackService } from '../feedback.service'

@Component({
  standalone: false,
  selector: 'vs-guest-feedback-form',
  templateUrl: './guest-feedback-form.component.html',
  styleUrls: ['./guest-feedback-form.component.scss'],
})
export class GuestFeedbackFormComponent implements OnInit {
  attachmentFiles: any
  guestFeedbackForm: FormGroup
  maxSubjectMessageLength: number = 500
  content: any = ''
  isSubmitted: boolean = false
  subjectDropdownContents: any = []
  //emailFormat: any = '/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/';
  //  '^([a-zA-Z0-9._%+-]+@(?!gmail.com|yahoo.com|hotmail.com)(?:[a-zA-Z0-9.-]+.?)(s*(,)s*|s*$))+$';
  loaderActivated: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private globalMessageService: GlobalMessageService,
    private feedbackService: FeedbackService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.createForm()
    this.fetchSubjectDropdown()
  }
  createForm() {
    this.guestFeedbackForm = this.formBuilder.group({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      phoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/),
        Validators.minLength(6),
        Validators.maxLength(16),
      ]),
      emailAddress: new FormControl('', [
        Validators.required,
        //Validators.pattern(this.emailFormat),
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      subjectChosen: new FormControl('', Validators.required),
      subjectMessage: new FormControl('', [
        Validators.required,
        Validators.maxLength(this.maxSubjectMessageLength),
      ]),
    })
  }

  acceptNumberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 43 &&
      charCode !== 45 &&
      charCode !== 40 &&
      charCode !== 41 &&
      charCode !== 46 &&
      charCode !== 62
    ) {
      return false
    }
    return true
  }

  checkLength(event) {
    this.content = event.target.value
  }

  updateFile(event) {
    this.attachmentFiles = event
  }

  removedFile(event) {
    let fileName: string = event
    let refreshFilesList = []
    if (this.attachmentFiles.length > 0) {
      for (let i = 0; i < this.attachmentFiles.length; i++) {
        if (
          this.attachmentFiles[i].name.trim().toString() !==
          fileName.trim().toString()
        ) {
          refreshFilesList.push(this.attachmentFiles[i])
        }
      }
    }
    this.attachmentFiles = refreshFilesList
  }

  fetchSubjectDropdown() {
    this.loaderActivated = true
    this.feedbackService.fetchSubjectforFeedback().subscribe(
      (data) => {
        if (data !== null && data !== undefined) {
          this.loaderActivated = false
          this.subjectDropdownContents = data['subject']
          if (
            this.subjectDropdownContents !== undefined &&
            this.subjectDropdownContents.length > 0 &&
            this.subjectDropdownContents[0].code !== undefined
          ) {
            this.guestFeedbackForm.controls['subjectChosen'].setValue(
              this.subjectDropdownContents[0].code
            )
          }
        } else {
          this.loaderActivated = false
          this.displayFeedbackFormLoadError()
        }
      },
      (error) => {
        this.loaderActivated = false
        this.displayFeedbackFormLoadError()
      }
    )
  }

  displayFeedbackFormLoadError() {
    this.globalMessageService.add(
      { key: 'help.issueFeedbackForm' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  submitFeedback() {
    this.isSubmitted = true

    if (this.guestFeedbackForm.valid) {
      const formData = new FormData()
      formData.append(
        'firstName',
        this.guestFeedbackForm.controls['firstName'].value
      )
      formData.append(
        'lastName',
        this.guestFeedbackForm.controls['lastName'].value
      )
      formData.append(
        'phoneNumber',
        this.guestFeedbackForm.controls['phoneNumber'].value
      )
      formData.append(
        'emailId',
        this.guestFeedbackForm.controls['emailAddress'].value
      )
      formData.append(
        'subjectTypeCode',
        this.guestFeedbackForm.controls['subjectChosen'].value
      )
      formData.append(
        'message',
        this.guestFeedbackForm.controls['subjectMessage'].value
      )

      if (
        this.attachmentFiles !== null &&
        this.attachmentFiles !== undefined &&
        this.attachmentFiles.length > 0
      ) {
        this.attachmentFiles.forEach((element) => {
          formData.append('multipartFile', element)
        })
      }
      this.loaderActivated = true
      this.feedbackService.submitGuestFeedback(formData).subscribe(
        (response) => {
          this.resetScreen()
          this.loaderActivated = false
          this.globalMessageService.add(
            { key: 'help.thanksForFeedback' },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            5000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.resetScreen()
          this.loaderActivated = false
          this.globalMessageService.add(
            { key: 'help.issueWhileSubmitFeedback' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    }
  }

  resetScreen() {
    this.isSubmitted = false
    this.attachmentFiles = []
    this.guestFeedbackForm.reset()
    this.guestFeedbackForm.markAsPristine()
    this.guestFeedbackForm.markAsUntouched()
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/feedback'])
    })
  }

  keyPressAllowAlphabetsOnly(event) {
    var inp = String.fromCharCode(event.keyCode)
    if (/[a-zA-Z]/.test(inp)) {
      return true
    } else {
      event.preventDefault()
      return false
    }
  }
}
